import { useContext } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import InventoryContext from '~/context/srp/InventoryContext';
import { useTradeInfo } from '~/context/srp/SearchContext';

export default function useDataForAnalytics() {
  const { appliedFilters, sortBy } = useContext(AppliedFiltersContext);
  const {
    inventory: {
      data: {
        searchRequestId,
        inventory: {
          pagination: { currentPage, totalMatchedInventory },
          vehicles
        },
        userDeliveryInfo
      }
    },
    similarVehicles: { vehicles: similarVehicles }
  } = useContext(InventoryContext);

  const tradeInfo = useTradeInfo();

  return {
    appliedFilters,
    currentPage,
    isDefaultFilters: Object.keys(appliedFilters)?.length === 0,
    searchRequestId,
    similarVehicles,
    sortBy,
    totalMatchedInventory,
    tradeInfo,
    userDeliveryInfo,
    vehicles
  };
}
